export default __webpack_public_path__ + "static/course-photo-example-1a7fb9cbb685ff21a5d2da7ab0f7a9f7.webp";